// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"c167c342","452":"9f22b15a","464":"7d1c5913","626":"602a095e","816":"5fbf6aec"}[chunkId] + ".chunk.js";
};